<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let profile = '';

	const PROFILE_DESC: Record<string, { key: string; default: string }> = {
		monophase: {
			key: 'settings_profile_desc_monophase',
			default: 'Measure each phase as its own circuit.',
		},
		triphase: {
			key: 'settings_profile_desc_triphase',
			default: 'Measure a three-phase load as one combined circuit.',
		},
		cover: {
			key: 'settings_profile_desc_cover',
			default: 'Control a roller shutter, blinds, or garage door.',
		},
		switch: {
			key: 'settings_profile_desc_switch',
			default: 'Control a regular on/off load such as a light or socket.',
		},
		light: {
			key: 'settings_profile_desc_light',
			default: 'Control a single white or tunable-white light.',
		},
		rgb: {
			key: 'settings_profile_desc_rgb',
			default: 'Control an RGB color light.',
		},
		rgbw: {
			key: 'settings_profile_desc_rgbw',
			default: 'Control an RGBW light with a dedicated white channel.',
		},
		rgbcct: {
			key: 'settings_profile_desc_rgbcct',
			default: 'Control RGB plus cold and warm white channels.',
		},
		cctx2: {
			key: 'settings_profile_desc_cctx2',
			default: 'Control two independent white lights.',
		},
		rgbx2light: {
			key: 'settings_profile_desc_rgbx2light',
			default: 'Control RGB on one output and a white light on the other.',
		},
	};

	$: copy = PROFILE_DESC[profile] ?? {
		key: 'settings_profile_desc_generic',
		default: 'Choose how this device should operate.',
	};
</script>

<Text styleType="body-small" class="text-color-muted">
	{$format(copy.key, { default: copy.default })}
</Text>
